import { useContext, useMemo } from 'react'
import * as FEATURES from '../../../../constants/features'
import * as SETTINGS from '../../../../constants/settings'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import { FILE_TYPES } from '../../../../utils/S3Uploads'
import { toastSuccess } from '../../../../utils/toast'
import UploadFile from '../../../Forms/common/UploadFile'
import Tooltip from '../../../Utilities/Tooltip'

const Video = () => {
  const {
    [SETTINGS.FEATURES.key]: enabledFeatures,
    [SETTINGS.VIDEO.key]: videos,
    updateSetting
  } = useContext(SiteConfigContext)

  const preStreamEnabled = useMemo(
    () => enabledFeatures && enabledFeatures[FEATURES.PRESTREAM],
    [enabledFeatures]
  )

  const setVideo = async (type, video, reason) => {
    const copy = { ...videos }
    copy[type] = video
    await updateSetting(SETTINGS.VIDEO, copy)
    toastSuccess(`Videos ${reason} successfully!`)
  }

  const updateVideo = (key) => (video) => {
    setVideo(key, video, 'Saved')
  }

  const handleVideoDelete = (key) => () => {
    setVideo(key, '', 'Deleted')
  }

  return (
    <>
      <div className="flex items-center">
        <h2 className="mr-3">Video Upload</h2>
        <Tooltip>
          Manage your welcome video—upload, update, or remove it.
        </Tooltip>
      </div>

      <div className="w-full divide-y divide-neutral-200 dark:divide-neutral-700 flex flex-col gap-4">
        <VideoSelection
          title="Welcome Video"
          videoUrl={videos.welcome}
          handleDelete={handleVideoDelete('welcome')}
          returnVideo={updateVideo('welcome')}
        />
        {preStreamEnabled && (
          <VideoSelection
            title="Pre-stream Video"
            videoUrl={videos.prestream}
            handleDelete={handleVideoDelete('prestream')}
            returnVideo={updateVideo('prestream')}
          />
        )}
      </div>
    </>
  )
}

const VideoSelection = ({ title, videoUrl, handleDelete, returnVideo }) => {
  return (
    <div className="w-full p-2 xl:p-5 flex flex-col xl:grid xl:grid-cols-[200px_1fr_1fr_auto] gap-4 items-start">
      <h2>{title}</h2>
      {videoUrl ? (
        <div className="flex flex-col gap-5">
          <video controls className="w-full rounded-lg">
            <source src={videoUrl} type="video/mp4" />
            <source src={videoUrl} type="video/webm" />
            <source src={videoUrl} type="video/ogg" />
            <source src={videoUrl} type="video/quicktime" />
            <source src={videoUrl} type="video/x-msvideo" />
            <source src={videoUrl} type="video/x-matroska" />
            Your browser does not support the video element.
          </video>
        </div>
      ) : (
        <div className="w-full bg-black p-5">
          <p className="text-gray-500">No video uploaded.</p>
        </div>
      )}
      <UploadFile returnURL={returnVideo} type={FILE_TYPES.VIDEO} />
      <button onClick={handleDelete} className="w-fit text-xs button-cancel">
        Remove
      </button>
    </div>
  )
}

export default Video
